<template>
  <div id="app">
    <main>
      <router-view></router-view>
    </main>
  </div>
</template>

<script>
  export default {
    name: 'App'
  }
</script>

<style lang="scss">
  /*@import 'assets/css/dev.scss';*/
  @import '../node_modules/bootstrap/scss/bootstrap.scss';

  @import 'assets/css/custom.scss';
  @import 'assets/css/home.scss';
  @import 'assets/css/imagepod.scss';
  @import 'assets/css/pageImageSlider.scss';
</style>



// WEBPACK FOOTER //
// src/App.vue